'use strict';

var _objectSpread = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Common = require('./common');
var Ref = require('./ref');
var internals = {};
exports.Ids = internals.Ids = /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
    this._byId = new Map();
    this._byKey = new Map();
    this._schemaChain = false;
  }
  _createClass(_class, [{
    key: "clone",
    value: function clone() {
      var clone = new internals.Ids();
      clone._byId = new Map(this._byId);
      clone._byKey = new Map(this._byKey);
      clone._schemaChain = this._schemaChain;
      return clone;
    }
  }, {
    key: "concat",
    value: function concat(source) {
      if (source._schemaChain) {
        this._schemaChain = true;
      }
      var _iterator = _createForOfIteratorHelper(source._byId.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            id = _step$value[0],
            value = _step$value[1];
          Assert(!this._byKey.has(id), 'Schema id conflicts with existing key:', id);
          this._byId.set(id, value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(source._byKey.entries()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            key = _step2$value[0],
            _value = _step2$value[1];
          Assert(!this._byId.has(key), 'Schema key conflicts with existing id:', key);
          this._byKey.set(key, _value);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "fork",
    value: function fork(path, adjuster, root) {
      var chain = this._collect(path);
      chain.push({
        schema: root
      });
      var tail = chain.shift();
      var adjusted = {
        id: tail.id,
        schema: adjuster(tail.schema)
      };
      Assert(Common.isSchema(adjusted.schema), 'adjuster function failed to return a joi schema type');
      var _iterator3 = _createForOfIteratorHelper(chain),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var node = _step3.value;
          adjusted = {
            id: node.id,
            schema: internals.fork(node.schema, adjusted.id, adjusted.schema)
          };
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return adjusted.schema;
    }
  }, {
    key: "labels",
    value: function labels(path) {
      var behind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var current = path[0];
      var node = this._get(current);
      if (!node) {
        return [].concat(_toConsumableArray(behind), _toConsumableArray(path)).join('.');
      }
      var forward = path.slice(1);
      behind = [].concat(_toConsumableArray(behind), [node.schema._flags.label || current]);
      if (!forward.length) {
        return behind.join('.');
      }
      return node.schema._ids.labels(forward, behind);
    }
  }, {
    key: "reach",
    value: function reach(path) {
      var behind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var current = path[0];
      var node = this._get(current);
      Assert(node, 'Schema does not contain path', [].concat(_toConsumableArray(behind), _toConsumableArray(path)).join('.'));
      var forward = path.slice(1);
      if (!forward.length) {
        return node.schema;
      }
      return node.schema._ids.reach(forward, [].concat(_toConsumableArray(behind), [current]));
    }
  }, {
    key: "register",
    value: function register(schema) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        key = _ref.key;
      if (!schema || !Common.isSchema(schema)) {
        return;
      }
      if (schema.$_property('schemaChain') || schema._ids._schemaChain) {
        this._schemaChain = true;
      }
      var id = schema._flags.id;
      if (id) {
        var existing = this._byId.get(id);
        Assert(!existing || existing.schema === schema, 'Cannot add different schemas with the same id:', id);
        Assert(!this._byKey.has(id), 'Schema id conflicts with existing key:', id);
        this._byId.set(id, {
          schema: schema,
          id: id
        });
      }
      if (key) {
        Assert(!this._byKey.has(key), 'Schema already contains key:', key);
        Assert(!this._byId.has(key), 'Schema key conflicts with existing id:', key);
        this._byKey.set(key, {
          schema: schema,
          id: key
        });
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this._byId = new Map();
      this._byKey = new Map();
      this._schemaChain = false;
    }
  }, {
    key: "_collect",
    value: function _collect(path) {
      var behind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var nodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var current = path[0];
      var node = this._get(current);
      Assert(node, 'Schema does not contain path', [].concat(_toConsumableArray(behind), _toConsumableArray(path)).join('.'));
      nodes = [node].concat(_toConsumableArray(nodes));
      var forward = path.slice(1);
      if (!forward.length) {
        return nodes;
      }
      return node.schema._ids._collect(forward, [].concat(_toConsumableArray(behind), [current]), nodes);
    }
  }, {
    key: "_get",
    value: function _get(id) {
      return this._byId.get(id) || this._byKey.get(id);
    }
  }]);
  return _class;
}();
internals.fork = function (schema, id, replacement) {
  var each = function each(item, _ref2) {
    var key = _ref2.key;
    if (id === (item._flags.id || key)) {
      return replacement;
    }
  };
  var obj = exports.schema(schema, {
    each: each,
    ref: false
  });
  return obj ? obj.$_mutateRebuild() : schema;
};
exports.schema = function (schema, options) {
  var obj;
  for (var name in schema._flags) {
    if (name[0] === '_') {
      continue;
    }
    var result = internals.scan(schema._flags[name], {
      source: 'flags',
      name: name
    }, options);
    if (result !== undefined) {
      obj = obj || schema.clone();
      obj._flags[name] = result;
    }
  }
  for (var i = 0; i < schema._rules.length; ++i) {
    var rule = schema._rules[i];
    var _result = internals.scan(rule.args, {
      source: 'rules',
      name: rule.name
    }, options);
    if (_result !== undefined) {
      obj = obj || schema.clone();
      var clone = Object.assign({}, rule);
      clone.args = _result;
      obj._rules[i] = clone;
      var existingUnique = obj._singleRules.get(rule.name);
      if (existingUnique === rule) {
        obj._singleRules.set(rule.name, clone);
      }
    }
  }
  for (var _name in schema.$_terms) {
    if (_name[0] === '_') {
      continue;
    }
    var _result2 = internals.scan(schema.$_terms[_name], {
      source: 'terms',
      name: _name
    }, options);
    if (_result2 !== undefined) {
      obj = obj || schema.clone();
      obj.$_terms[_name] = _result2;
    }
  }
  return obj;
};
internals.scan = function (item, source, options, _path, _key) {
  var path = _path || [];
  if (item === null || typeof item !== 'object') {
    return;
  }
  var clone;
  if (Array.isArray(item)) {
    for (var i = 0; i < item.length; ++i) {
      var key = source.source === 'terms' && source.name === 'keys' && item[i].key;
      var result = internals.scan(item[i], source, options, [i].concat(_toConsumableArray(path)), key);
      if (result !== undefined) {
        clone = clone || item.slice();
        clone[i] = result;
      }
    }
    return clone;
  }
  if (options.schema !== false && Common.isSchema(item) || options.ref !== false && Ref.isRef(item)) {
    var _result3 = options.each(item, _objectSpread({}, source, {
      path: path,
      key: _key
    }));
    if (_result3 === item) {
      return;
    }
    return _result3;
  }
  for (var _key2 in item) {
    if (_key2[0] === '_') {
      continue;
    }
    var _result4 = internals.scan(item[_key2], source, options, [_key2].concat(_toConsumableArray(path)), _key);
    if (_result4 !== undefined) {
      clone = clone || Object.assign({}, item);
      clone[_key2] = _result4;
    }
  }
  return clone;
};